<template lang="pug">
  //- 404 Error
  section.section
    .content.has-text-grey.has-text-centered.mt-20
      p: b-icon(icon="emoticon-sad" size="is-large")
      p: strong Страница не найдена

      slot

      b-button.mr-10(@click="$router.go(-1)" icon-left="arrow-left-bold") Назад
      b-button(@click="$router.replace('/')" icon-left="home") На главную
</template>

<script>
export default {
  name: 'page-not-found',
};
</script>
